import { useEffect, useState } from "react";
import supabase from "../../../../utils/supabase";

/**
 * Resolves a chapter's display number from its DB id.
 *
 * Launch URLs carry `chapter_id` (the pe_chapters PK, which is offset from the
 * per-season chapter number — e.g. id 8 == Season 1, Chapter 7). Banners must
 * show the human chapter NUMBER, never the raw id. We look up
 * pe_chapters.chapter_number (RLS allows authenticated SELECT) rather than
 * assuming a fixed offset, which only holds within Season 1.
 *
 * Returns null while loading / if unknown — callers should fall back to a
 * neutral placeholder, never to the raw chapter_id.
 */
export function useChapterNumber(chapterId: string | null): number | null {
  const [chapterNumber, setChapterNumber] = useState<number | null>(null);

  useEffect(() => {
    if (!chapterId || chapterId === "practice") {
      setChapterNumber(null);
      return;
    }
    let cancelled = false;
    supabase
      .from("pe_chapters")
      .select("chapter_number")
      .eq("id", chapterId)
      .single()
      .then(({ data }) => {
        if (!cancelled) setChapterNumber(data?.chapter_number ?? null);
      });
    return () => {
      cancelled = true;
    };
  }, [chapterId]);

  return chapterNumber;
}
